<div class="relative min-h-full fireworks">
  <div class="absolute inset-0">
    <!-- Background Image -->
    <img class="h-full w-full object-cover object-left" src="assets/images/branding/bg-cover.png" alt="" />
  </div>

  <div class="relative flex justify-center items-center min-h-screen">
    <div
      class="mx-auto w-full max-w-md lg:w-96 py-16 px-8 rounded-2xl bg-white dark:bg-zinc-950 backdrop-blur-2xl z-10 shadow-sm ring-1 ring-zinc-950/10 dark:ring-white/10">

      <div class="flex flex-col items-center">
        <img class="h-32 w-auto object-scale-down" src="assets/images/branding/logo.png" alt="logo" />
        <h2 class="mt-6 heading text-3xl font-bold text-center text-main-dark tracking-tight">Sign in to your account
        </h2>
      </div>

      <div class="mt-8">
        <form [formGroup]="signInForm" (ngSubmit)="onSignIn()" class="space-y-6">

          <!-- Email Input -->
          <div>
            <label for="email" class="subheading after:ml-0.5 after:text-red-500 after:content-['*']">Email
              Address</label>
            <div class="mt-2">
              <input id="email" name="email" formControlName="email" type="email" autocomplete="email"
                class="input-class w-full" />
            </div>

            <div *ngIf="form.email.errors && submitted">
              <div *ngIf="form.email.errors.required" class="error">
                <p class="mt-2 text-xs text-red-500" id="email-description">Email is required</p>
              </div>
              <div *ngIf="form.email.errors.email" class="error">
                <p class="mt-2 text-xs text-red-500" id="email-description">Invalid Email format</p>
              </div>
            </div>
          </div>

          <!-- Password Input -->
          <div class="space-y-1">
            <label for="password"
              class="subheading after:ml-0.5 after:text-red-500 after:content-['*']">Password</label>
            <div class="flex flex-1 gap-2 items-center mt-2 relative">
              <div class="flex-1 relative">
                <input id="password" type="{{passwordToggleFlag ? 'password' : 'text'}}" formControlName="password"
                  name="password" autocomplete="current-password" class="input-class w-full pr-10" />
                <span class="absolute inset-y-0 right-2 flex items-center cursor-pointer text-gray-500"
                  (click)="togglePasswordType()">
                  <ng-container *ngIf="passwordToggleFlag; else hideIcon">
                    <!-- Eye Slash Icon -->
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                      stroke="currentColor" class="size-6">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
                    </svg>
                  </ng-container>
                  <ng-template #hideIcon>
                    <!-- Eye Icon -->
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                      stroke="currentColor" class="size-6">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                    </svg>
                  </ng-template>
                </span>
              </div>
            </div>

            <div *ngIf="form.password.errors && submitted">
              <div *ngIf="form.password.errors.required" class="error">
                <p class="mt-2 text-xs text-red-500">Password is required</p>
              </div>
              <div *ngIf="form.password.errors.minlength" class="error">
                <p class="mt-2 text-xs text-red-500">Password must be at least 8 chars with letters & numbers</p>
              </div>
            </div>
          </div>
          <!-- toggle -->
          <div class="flex justify-between items-center mt-4">
            <div class="text-xs font-bold">{{ isCompany ? 'Company' : 'Staff' }}</div>
            <div>
              <button type="button" (click)="toggleRole()" class="relative inline-flex items-center h-6 w-12 rounded-full transition-colors duration-300 ease-in-out
                   border-2 focus:outline-none focus:ring-2 focus:ring-offset-2" [ngStyle]="{
              'background-color': isCompany ? '#249ab7' : '#e5e7eb',
              'border-color': isCompany ? '#249ab7' : '#d1d5db'
            }" role="switch" [attr.aria-checked]="isCompany">

                <!-- Slider Circle -->
                <span [ngClass]="isCompany ? 'translate-x-6' : 'translate-x-0'"
                  class="inline-block h-4 w-4 transform rounded-full bg-white shadow-md transition-transform duration-300 ease-in-out flex items-center justify-center">

                  <!-- Checkmark when enabled -->
                  <svg *ngIf="isCompany" class="h-3 w-3 text-white" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor" stroke-width="3">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                  </svg>

                </span>
              </button>
            </div>
          </div>


          <!-- Submit Button -->
          <div>
            <button type="submit" class="btn btn-primary w-full">Sign In</button>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>